import { cn, type TabItem, Tabs } from "@kyan/ui";
import { usePathname, useRouter } from "next/navigation";

import { useTopBannerFeatureFlag } from "#/hooks/featureFlags/useTopBannerFeatureFlag";

export interface SidebarProps {
  items: TabItem[];
}

export const Sidebar: React.FC<SidebarProps> = ({ items }) => {
  const router = useRouter();
  const pathname = usePathname();
  const { showTopBanner } = useTopBannerFeatureFlag();

  return (
    <aside
      className={cn(
        "border-divider fixed top-20 left-0 h-full max-w-36 min-w-36 border-r pt-10",
        {
          "top-38": showTopBanner,
        },
      )}
    >
      <Tabs
        vertical
        items={items}
        value={pathname}
        variant="primary"
        className="w-full gap-0"
        itemClassName="w-full min-h-[46px] h-[46px] font-sans"
        onChange={(path) => {
          router.push(path);
        }}
      />
    </aside>
  );
};
